
export default function FormsExtensionBenefits() {
  const benefits = [
    {
      icon: 'ri-time-line',
      title: '提升效率',
      description: '自动化处理表单，减少90%的人工录入时间',
      stat: '90%',
      statLabel: '时间节省'
    },
    {
      icon: 'ri-error-warning-line',
      title: '降低错误',
      description: 'AI智能识别，将人工录入错误率降低95%',
      stat: '95%',
      statLabel: '错误减少'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: '节约成本',
      description: '减少人力投入，每年节省数十万运营成本',
      stat: '70%',
      statLabel: '成本降低'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '优化体验',
      description: '快速响应，提升客户满意度和业务效率',
      stat: '85%',
      statLabel: '满意度提升'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-teal-50 via-cyan-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            <strong>业务价值</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            为企业带来实实在在的<strong>效率提升</strong>和<strong>成本节约</strong>
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="w-16 h-16 flex items-center justify-center rounded-xl bg-gradient-to-br from-teal-500 to-cyan-500 mb-6">
                <i className={`${benefit.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                <strong>{benefit.title}</strong>
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                {benefit.description}
              </p>
              <div className="border-t border-gray-200 pt-4">
                <div className="text-3xl font-bold text-teal-600 mb-1">
                  {benefit.stat}
                </div>
                <div className="text-sm text-gray-500">
                  {benefit.statLabel}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
